import { useQuery } from 'react-query';
import { Navigate, useParams } from 'react-router-dom';
import requestService from '../../services/request.service';
import { NotFoundSchedule } from '../NotFoundSchedule';

export const ShortRequestRedirect = () => {
  const { code = '' } = useParams<{ code: string }>();
  const { data: requestId, isError } = useQuery(
    ['patient-request-short-link', code],
    () => requestService.resolveShortRequest(code),
    { retry: false }
  );

  if (isError) {
    return <NotFoundSchedule />;
  }

  if (!requestId) return null;

  return <Navigate to={`/requests/${requestId}`} replace />;
};
